<template>
  <div v-if="!loading">
    <setting-item
      name="Finalização automática do prontuário"
      description="Quando ativo, o sistema finaliza automaticamente os atendimentos em
        aberto após a quantidade de horas definida."
      type="switch"
      :value="form.medicalRecord.autoFinishEnabled"
      :action-icon="['fal', 'cog']"
      :action-fn="() => { medicalRecordAutoFinishModal.show = true }"
      :action-disabled="form.medicalRecord.autoFinishEnabled === false"
      @change="updateValue('autoFinishEnabled', $event, 'medicalRecord')"
    ></setting-item>

    <dx-modal
      v-model="medicalRecordAutoFinishModal.show"
      title="Finalização automática"
      size="sm"
    >
      <div class="form-group">
        <label
          for="auto-finish-hours"
          class="form-label"
        >Tempo para a finalização do prontuário</label>
        <div class="input-group">
          <input
            type="number"
            class="form-input"
            id="auto-finish-hours"
            v-model="form.medicalRecord.autoFinishAfterHours"
            placeholder="36"
            min="1"
          >
          <span class="input-group-addon">horas</span>
        </div>
      </div>
      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-primary"
          :class="{ loading: saving }"
          :disabled="saving || !form.medicalRecord.autoFinishAfterHours"
          @click="updateGroup('medicalRecord')"
        >Salvar</button>
        <button
          type="button"
          class="btn ml-2"
          @click="medicalRecordAutoFinishModal.show = false"
        >Sair</button>
      </template>
    </dx-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mergeFrom } from '@/helpers/object';
import SettingItem from '../SettingItem.vue';

export default {
  props: {
    loading: {
      type: Boolean,
    },
    settings: {
      type: Object,
    },
  },
  components: {
    SettingItem,
  },
  data() {
    return {
      saving: false,
      form: this.blankForm(),
      medicalRecordAutoFinishModal: {
        show: false,
      },
    };
  },
  watch: {
    loading() {
      this.updateForm();
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    customerId() {
      return this.user && this.user.facility ? this.user.facility.customerId : null;
    },
  },
  methods: {
    updateForm() {
      this.form = mergeFrom(this.form, this.settings);
    },
    async updateGroup(group) {
      await this.update({
        [group]: this.form[group],
      });
    },
    async updateValue(key, value, group) {
      await this.update({
        [group]: {
          [key]: value,
        },
      });
      this.form[group][key] = value;
    },
    async update(data = null) {
      this.saving = true;
      try {
        await this.$http.put('/facility-settings', data || this.form);
        this.$toast.success('Configuração salva com sucesso');
      } catch (e) {
        this.$toast.error(e);
      }
      this.saving = false;
    },
    blankForm() {
      return {
        medicalRecord: {
          autoFinishEnabled: false,
          autoFinishAfterHours: 0,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/_variables.scss";
</style>
